/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_P1_AfterInputs */

const tr_hakkimizda_s4_p1_after = /** @type {(inputs: Hakkimizda_S4_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` tarafından işletilmekte; veri sorumluluğu ve sözleşme tarafı Emonse® E-Ticaret Limited Şirketi'dir.`)
};

const en_hakkimizda_s4_p1_after = /** @type {(inputs: Hakkimizda_S4_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; the data controller and contracting party is Emonse® E-Ticaret Limited Şirketi.`)
};

const de_hakkimizda_s4_p1_after = /** @type {(inputs: Hakkimizda_S4_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` betrieben; Datenverantwortliche und Vertragspartei ist die Emonse® E-Ticaret Limited Şirketi.`)
};

const ru_hakkimizda_s4_p1_after = /** @type {(inputs: Hakkimizda_S4_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; ответственным за данные и стороной договора является Emonse® E-Ticaret Limited Şirketi.`)
};

/**
* | output |
* | --- |
* | "; the data controller and contracting party is Emonse® E-Ticaret Limited Şirketi." |
*
* @param {Hakkimizda_S4_P1_AfterInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_p1_after = /** @type {((inputs?: Hakkimizda_S4_P1_AfterInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_P1_AfterInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_p1_after(inputs)
	if (locale === "de") return de_hakkimizda_s4_p1_after(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_p1_after(inputs)
	return tr_hakkimizda_s4_p1_after(inputs)
});